module.exports = __webpack_public_path__ + "img/vsHandCream1.aa7aaae2.jpg";